import { render, staticRenderFns } from "./secondSelf.vue?vue&type=template&id=fa657d9a&"
import script from "./secondSelf.vue?vue&type=script&lang=js&"
export * from "./secondSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports